import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inflation-adjusted-return-calculator',
  component: () => import('../../routes/InflationAdjustedReturnCalculator.svelte'),
  card: {
    id: 'inflation-adjusted-return-calculator',
    title: 'Inflation-Adjusted Return Calculator',
    description: 'Calculate your real investment return after accounting for inflation using the Fisher equation.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/inflation-adjusted-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Inflation-Adjusted Return Calculator – Real vs Nominal Returns',
    description:
      'Free inflation-adjusted return calculator to find your real investment return after inflation. Uses the Fisher equation: real return = ((1 + nominal) / (1 + inflation)) − 1.',
  },
};

export default meta;
